import { Card as ACard, CardProps } from "antd";

import React from "react";
import { shadows } from "../../styling/shadow";
import { ShadowSize } from "../../types";

export type Props = {
  shadowSize?: ShadowSize;
} & CardProps;

const Card = ({ children, style, bodyStyle, shadowSize = "base", ...props }: Props) => {
  const boxShadow = shadows[shadowSize];
  return (
    <ACard
      style={{
        boxShadow,
        background: "#ffffff",
        borderRadius: 0,
        border: "none",
        ...style,
      }}
      bodyStyle={{
        padding: "18px 12px",
        ...bodyStyle,
      }}
      {...props}
    >
      {children}
    </ACard>
  );
};

export default Card;
